import { ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const forgeFieldContextualConfigurationRoute: InvariantRoute = {
	name: ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION,
	path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app',
};
